














import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Content, TDocumentDefinitions } from "pdfmake/interfaces";
if (!(pdfMake as { vfs?: unknown }).vfs) {
  (pdfMake as { vfs: unknown }).vfs = (pdfFonts as { pdfMake: { vfs: unknown } })
    .pdfMake.vfs;
}

const EMPRESA = {
  nombre: "INVERSIONES SANTA FIDELMIRA S.A",
  nombreCorto: "Sta. Fidelmira",
  rut: "79.991.280-5",
};

interface CajaChica {
  numero: string;
  periodo: string;
  fecha: string;
  rutProveedor: string;
  nombreProveedor: string;
  accion: string;
  ingreso: string;
  egreso: string;
  documento: string;
  concepto: string;
  descripcion: string;
}
function formatearMonto(val: string | number | undefined | null): string {
  if (val === undefined || val === null || val === "") return "-";
  const num = typeof val === "string" ? parseFloat(val.replace(/\./g, "").replace(",", ".")) : Number(val);
  if (Number.isNaN(num)) return "-";
  return "$" + Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function aNumero(val: string | number | undefined | null): number {
  if (val === undefined || val === null || val === "") return 0;
  const num = typeof val === "string" ? parseFloat(val.replace(/\./g, "").replace(",", ".")) : Number(val);
  return Number.isNaN(num) ? 0 : num;
}

@Component
export default class ExportarPdf extends Vue {
  @Prop({ type: Array, required: true }) itemSelected!: CajaChica[];
  @Prop({ default: null }) periodoSeleccionado!: { label?: string; value?: string } | null;

  celda(texto: string, fill: string, extra: string[] = []): Content {
    return { text: texto || "—", style: ["tableCell", ...extra], fillColor: fill };
  }

  exportPdf(): void {
    const morado = "#0e4c88";
    const moradoSuave = "#f3f7fb";
    let sumaIngresos = 0;
    let sumaEgresos = 0;
    const encabezado: Content[] = ["N°", "Periodo", "Fecha", "RUT", "Proveedor", "Acción", "Ingreso", "Egreso", "Documento", "Concepto", "Descripción"].map((texto) => ({
      text: texto,
      style: "tableHeader",
    }));
    const filas = this.itemSelected.map((item, index) => {
      const fill = index % 2 === 0 ? moradoSuave : "#ffffff";
      sumaIngresos += aNumero(item.ingreso);
      sumaEgresos += aNumero(item.egreso);
      return [
        this.celda(String(item.numero ?? ""), fill),
        this.celda(item.periodo ?? "", fill),
        this.celda(item.fecha ?? "", fill),
        this.celda(item.rutProveedor ?? "", fill, ["izq"]),
        this.celda(item.nombreProveedor ?? "", fill, ["izq"]),
        this.celda(item.accion ?? "", fill),
        this.celda(formatearMonto(item.ingreso), fill, ["monto", "ingreso"]),
        this.celda(formatearMonto(item.egreso), fill, ["monto", "egreso"]),
        this.celda(item.documento ?? "", fill, ["izq"]),
        this.celda(item.concepto ?? "", fill, ["izq"]),
        this.celda(item.descripcion ?? "", fill, ["izq"]),
      ];
    });
    const totalFill = "#e8f1f8";
    filas.push([
      { text: "Totales", style: "totalLabel", fillColor: totalFill, colSpan: 6 } as Content,
      { text: "" }, { text: "" }, { text: "" }, { text: "" }, { text: "" },
      { text: formatearMonto(sumaIngresos), style: ["totalLabel", "monto", "ingreso"], fillColor: totalFill },
      { text: formatearMonto(sumaEgresos), style: ["totalLabel", "monto", "egreso"], fillColor: totalFill },
      { text: "", fillColor: totalFill, colSpan: 3 } as Content,
      { text: "" }, { text: "" },
    ]);
    const periodo = this.periodoSeleccionado?.label || this.periodoSeleccionado?.value || "Todos los periodos";
    const fechaReporte = new Date().toLocaleString("es-CL", { day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
    const docDefinition: TDocumentDefinitions = {
      pageOrientation: "landscape",
      pageMargins: [28, 28, 28, 36],
      footer: (pagina: number, total: number) => ({
        text: `${EMPRESA.nombreCorto}  ·  Caja chica  ·  Página ${pagina} de ${total}`,
        alignment: "center",
        fontSize: 8,
        color: "#6b7280",
        margin: [0, 8, 0, 0],
      }),
      content: [
        {
          table: {
            widths: ["*"],
            body: [[{
              fillColor: morado,
              margin: [12, 10, 12, 10],
              stack: [
                { text: EMPRESA.nombre, color: "white", bold: true, fontSize: 12 },
                { text: EMPRESA.rut, color: "#dbeafe", fontSize: 8, margin: [0, 3, 0, 0] },
              ],
            }]],
          },
          layout: "noBorders",
          margin: [0, 0, 0, 12],
        },
        {
          columns: [
            {
              width: "*",
              stack: [
                { text: "Reporte de caja chica · Talca Gerencial", style: "title" },
                { text: periodo, style: "subtitle" },
              ],
            },
            { width: "auto", text: fechaReporte, style: "fecha", alignment: "right" },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          columns: [
            { width: "*", text: [{ text: "Registros\n", style: "kpiLabel" }, { text: String(this.itemSelected.length), style: "kpiValor" }] },
            { width: "*", text: [{ text: "Suma ingresos\n", style: "kpiLabel" }, { text: formatearMonto(sumaIngresos), style: "kpiIngreso" }] },
            { width: "*", text: [{ text: "Suma egresos\n", style: "kpiLabel" }, { text: formatearMonto(sumaEgresos), style: "kpiEgreso" }] },
          ],
          columnGap: 8,
          margin: [0, 0, 0, 12],
        },
        {
          table: {
            headerRows: 1,
            widths: [22, 52, 52, 62, "*", 58, 58, 58, 72, 64, "*"],
            body: [encabezado, ...filas],
          },
          layout: {
            hLineWidth: () => 0.4,
            vLineWidth: () => 0,
            hLineColor: () => "#e5e7eb",
            paddingLeft: () => 4,
            paddingRight: () => 4,
            paddingTop: () => 4,
            paddingBottom: () => 4,
          },
        },
      ],
      styles: {
        title: { fontSize: 16, bold: true, color: morado },
        subtitle: { fontSize: 10, color: "#6b7280", margin: [0, 2, 0, 0] },
        fecha: { fontSize: 8, color: "#6b7280" },
        kpiLabel: { fontSize: 7, bold: true, color: "#6b7280" },
        kpiValor: { fontSize: 12, bold: true, color: morado },
        kpiIngreso: { fontSize: 12, bold: true, color: "#0d9488" },
        kpiEgreso: { fontSize: 12, bold: true, color: "#dc2626" },
        tableHeader: { bold: true, fontSize: 7, fillColor: morado, color: "white", alignment: "center" },
        tableCell: { fontSize: 7, alignment: "center", color: "#1f2937" },
        izq: { alignment: "left" },
        monto: { alignment: "right" },
        ingreso: { color: "#0d9488" },
        egreso: { color: "#dc2626" },
        totalLabel: { bold: true, fontSize: 8, color: morado, alignment: "right" },
      },
      defaultStyle: { fontSize: 8 },
    };
    pdfMake.createPdf(docDefinition).download("Reporte_Caja_Chica.pdf");
  }
}
